import { render, staticRenderFns } from "./identifyTenant.vue?vue&type=template&id=29b8de42&scoped=true"
import script from "./identifyTenant.vue?vue&type=script&lang=js"
export * from "./identifyTenant.vue?vue&type=script&lang=js"
import style0 from "./identifyTenant.vue?vue&type=style&index=0&id=29b8de42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b8de42",
  null
  
)

export default component.exports